import { render, staticRenderFns } from "./TopUpModal.vue?vue&type=template&id=28becc6c&scoped=true&"
import script from "./TopUpModal.vue?vue&type=script&lang=js&"
export * from "./TopUpModal.vue?vue&type=script&lang=js&"
import style0 from "./TopUpModal.vue?vue&type=style&index=0&id=28becc6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28becc6c",
  null
  
)

export default component.exports